package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.ShiftTemplate
import com.evoapps.evoshift.domain.model.DayTemplate
import com.evoapps.evoshift.domain.repository.WorkplaceRepository

class UpdateShiftTemplateUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    suspend operator fun invoke(
        workplaceId: String,
        template: ShiftTemplate
    ): Result<Unit> {
        return workplaceRepository.updateShiftTemplate(workplaceId, template)
    }
}

class DeleteShiftTemplateUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    suspend operator fun invoke(
        workplaceId: String,
        templateId: String
    ): Result<Unit> {
        // 1. Sprawdź czy definicja jest używana w jakimkolwiek szablonie dnia
        val dayTemplatesResult = workplaceRepository.getDayTemplates(workplaceId)

        if (dayTemplatesResult.isFailure) {
            return Result.failure(
                dayTemplatesResult.exceptionOrNull() ?: Exception("Błąd pobierania szablonów dni")
            )
        }

        // SH-190: a shift template the day templates use goes out of them too, in the same batch.
        // Shifts already in rosters are copies (times, role, skills) and keep no link to it.
        val withoutIt = dayTemplatesResult.getOrThrow()
            .filter { templateId in it.shiftTemplateIds }
            .map { it.withoutShiftTemplate(templateId) }

        // 2. Jeśli nie jest używana, usuń
        return workplaceRepository.deleteShiftTemplate(workplaceId, templateId, withoutIt)
    }
}
/** The day template without any occurrence of the shift template [shiftTemplateId]. */
fun DayTemplate.withoutShiftTemplate(shiftTemplateId: String): DayTemplate =
    copy(shiftTemplateIds = shiftTemplateIds.filterNot { it == shiftTemplateId })
